// src/lib/regions.js
import {
  DEFAULT_ISLAND_KEY,
  getIslandRegionColorMap,
  getIslandRegionDefinitions,
  getIslandRegionSlugMap,
} from 'alakai-aloha-shared';

export const getRegions = (islandKey = DEFAULT_ISLAND_KEY) =>
  getIslandRegionDefinitions(islandKey).map((region) => region.title);

export const getRegionSlugMap = (islandKey = DEFAULT_ISLAND_KEY) =>
  getIslandRegionSlugMap(islandKey);

export const getRegionColorMap = (islandKey = DEFAULT_ISLAND_KEY) =>
  getIslandRegionColorMap(islandKey);

export const REGIONS = getRegions('kauai');

export const REGION_SLUG = getRegionSlugMap('kauai');

export const REGION_COLOR = getRegionColorMap('kauai');
